/**
 * State
 */
const state = {
    contactReasons: {}
};

/**
 * Getters
 */
const getters = {
    contactReasons: (state) => state.contactReasons,
};

/**
 * Actions
 */
const actions = {
    /** Retrieve the list of contact reasons */
    retrieveContactReasons({commit}) {
        return new Promise((resolve, reject) => {
            this.$axios.get(`/api/v4/contact-request-reason`)
                .then(response => {
                    commit('SET_CONTACT_REASONS', response.data.data);
                    resolve();
                }).catch(() => {
                    reject();
                })
        });
    },

    sendMessage(__, {name, email, phone, reason, message, token, carrier}) {
        return new Promise((resolve, reject) => {
            let data = {
                'name': name,
                'email': email,
                'phone': phone,
                'reason': reason,
                'message': message,
                'g_recaptcha_response': token,
                'carrier': carrier
            }

            this.$axios.post(`/api/v4/contact/post`, data)
                .then(() => {
                    resolve();
                }).catch(e => {
                reject(e);
            });
        })
    },

    requestCallBackForNoDates({getters}, {modelVersionId, postcode, name, email, phone, carrier}) {
        return new Promise((resolve, reject) => {
            let data = {
                model_version_id: modelVersionId,
                postcode: postcode,
                name: name,
                email: email,
                phone: phone,
                carrier: carrier
            };

            this.$axios.post(`/api/v4/wefix-booking/${getters.reference}/request-call-back`, data)
                .then(() => {
                    resolve();
                }).catch(e => {
                    reject(e);
                });
        })
    }
};

/**
 * Mutations
 */
const mutations = {
    SET_CONTACT_REASONS(state, response) {
        state.contactReasons = response;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}